import O1HD from "../../../../engines/gameEngine";

const { ccclass, property, menu } = cc._decorator;

export interface ChessPointInfo {
    id: number,
    connected: number[],
    put: ChessObj,
    node: cc.Node,
    PointType: PointType
}

export enum ChessObj {
    Famer,//农民
    Cattle,//牛
    None
}

export enum PointType {
    Bullpen,
    Export,
    Normal
}

export interface FamerInfo {
    node: cc.Node,
    point: ChessPointInfo,
}


@ccclass
@menu('游戏脚本/主要模式/HCY/')
export default class HCY_FamerAndCattle extends cc.Component {

    @property({ type: cc.Node, displayName: "牛" })
    protected Cattle: cc.Node = null;

    @property({ type: cc.Node, displayName: "农民1" })
    protected Famer1: cc.Node = null


    @property({ type: cc.Node, displayName: "农民2" })
    protected Famer2: cc.Node = null

    protected AllChessInfo: ChessPointInfo[] = [];

    protected CanCtr: boolean = true;

    protected CurrFamer: FamerInfo = null;

    protected Export: ChessPointInfo[] = [];

    @property({ displayName: "提示文本" })
    protected tipsName: string = '农民';

    // async Init(info: INormalLevelStruct) {
    //     super.Init(info);
    // }

    start() {
        this.GameInit();
    }

    GameInit() {

        console.log('');

        let famer: ChessPointInfo[] = []
        this.AllChessInfo.forEach(point => {
            if (point.put == ChessObj.Famer) {
                famer.push(point);
            }
            if (point.PointType == PointType.Export) {
                this.Export.push(point)
            }
        })
        let info1: FamerInfo = {
            node: this.Famer1,
            point: famer[0]
        }
        this.Famer1.setPosition(info1.point.node.getPosition());
        this.Famer1.children[0].on(cc.Node.EventType.TOUCH_START, (e) => {
            this.ClickFamer(e, info1);
        });
        let Info2: FamerInfo = {
            node: this.Famer2,
            point: famer[1]
        }
        this.Famer2.setPosition(Info2.point.node.getPosition());
        this.Famer2.children[0].on(cc.Node.EventType.TOUCH_START, (e) => {
            this.ClickFamer(e, Info2);
        });

    }

    MoveToClickPoint(point: ChessPointInfo)//将当前选中农民移往目标点
    {
        if (this.CurrFamer == null)//请选择当前需要操作的农民
        {
            O1HD.getModules().uiControlModule.showMessageBox("请选择当前需要操作的" + this.tipsName)
            return
        }

        if (this.CurrFamer.point.connected.indexOf(point.id) == -1)//不在联通点内
        {
            O1HD.getModules().uiControlModule.showMessageBox("无法前往这个地方")
            return
        }
        if (point.put !== ChessObj.None) {
            O1HD.getModules().uiControlModule.showMessageBox("无法前往这个地方")
            return
        }

        if( !this.CanCtr)
            return
        this.CanCtr = false;
        this.CurrFamer.point.put = ChessObj.None;
        this.SetConnectLight(this.CurrFamer.point, false)
        this.CurrFamer.point = point;
        this.CurrFamer.point.put = ChessObj.Famer;
        cc.tween(this.CurrFamer.node).to(0.5, { x: this.CurrFamer.point.node.x, y: this.CurrFamer.point.node.y }).call(() => {
            this.CanCtr = true;

            this.CheckAndMoveCattle(() => {
                this.SetConnectLight(this.CurrFamer.point, true)
            })
        }).start()

    }


    ClickFamer(e: cc.Event.EventTouch, info: FamerInfo)//点击选择当前操作的农民
    {
        this.CurrFamer && this.CurrFamer.node.stopAllActions()
        this.CurrFamer && this.SetConnectLight(this.CurrFamer.point, false);//取消之前的闪烁
        this.CurrFamer = info;
        this.CurrFamer && this.SetConnectLight(this.CurrFamer.point, true);//取消之前的闪烁
        let tween = cc.tween(this.CurrFamer.node).to(0.5, { scale: 1.2 }).to(0.5, { scale: 1 });
        cc.tween(this.CurrFamer.node).repeatForever(tween).start()
    }


    PushChessInfo(Info: ChessPointInfo) {
        this.AllChessInfo.push(Info);
    }

    getCloseToExport(Point: ChessPointInfo) {
        let close: number = null;
        this.Export.forEach(po => {
            let dis = po.node.getPosition().sub(Point.node.getPosition()).mag();
            if (close == null) {
                close = dis;
            } else {
                if (dis < close) {
                    close = dis;
                }
            }
        })
        return close
    }

    CheckAndMoveCattle(call: Function)//牛儿走一步
    {
        if (!this.CanCtr) {
            return;
        }
        let currPoint: ChessPointInfo = null;//当前所在的点
        let GoPoint: ChessPointInfo = null;//需要前往的点
        this.AllChessInfo.forEach((point) => {
            if (point.put == ChessObj.Cattle)//找到牛牛节点
            {
                currPoint = point;
            }
        })

        let Cango = this.GetCanGo(currPoint);
        let NewCanGo: ChessPointInfo[] = [];//新的可去点此组只包含优先去出口的点
        Cango.forEach(point => {
            if (point.PointType == PointType.Export)//出口
            {
                NewCanGo.push(point);
            }
        })
        if (NewCanGo.length > 0) {
            let n = Math.floor(Math.random() * NewCanGo.length);
            GoPoint = NewCanGo[n];
        } else {
            if (Cango.length > 1) {
                Cango.forEach((point, index) => {
                    if (point.PointType == PointType.Bullpen)//有别的位置可去则必不肯去牛栏
                    {
                        Cango.splice(index, 1);
                    }
                })
                Cango.sort((a, b) => {
                    return this.getCloseToExport(a) - this.getCloseToExport(b)
                })
                GoPoint = Cango[0];
            } else//只有一个去处
            {
                GoPoint = Cango[0];
            }
        }

        currPoint.put = ChessObj.None; //去掉当前位置上的所放
        this.CanCtr = false;
        cc.tween(this.Cattle).to(0.5, { x: GoPoint.node.x, y: GoPoint.node.y }).call(() => {
            this.CanCtr = true;
            GoPoint.put = ChessObj.Cattle;
            if (GoPoint.PointType == PointType.Bullpen)//如果去了牛栏
            {
                this.Cattle.children[0].opacity = 255
                // this.Win(cc.v2(0, 0));
                //TODO 胜利
                return
            }

            if (GoPoint.PointType == PointType.Export)//如果去了出口
            {
                // this.Lose(cc.v2(0, 0));
                //TODO 失败
                return
            }
            call && call()
        }).start()
    }

    GetCanGo(point: ChessPointInfo) {
        let CanGo: ChessPointInfo[] = [];
        point.connected.forEach(id => {
            let info = this.getPointById(id);
            if (info.put == ChessObj.None)//上面空无一物
            {
                CanGo.push(info)
            }
        })
        return CanGo
    }

    getPointById(id: number)//通过ID获取点
    {
        let target: ChessPointInfo = null;
        this.AllChessInfo.forEach((point) => {
            if (id == point.id) {
                target = point
            }
        })

        return target
    }


    SetConnectLight(point: ChessPointInfo, Light: boolean) {
        let cango = this.GetCanGo(point);
        if (Light) {
            cango.forEach(p => {
                p.node.children[0].stopAllActions()
                let tween = cc.tween(p.node.children[0]).to(0.5, { scale: 1.2 }).to(0.5, { scale: 1 })
                cc.tween(p.node.children[0]).repeatForever(tween).start()
            })
        } else {
            cango.forEach(p => {
                p.node.children[0].stopAllActions()
                p.node.children[0].color = cc.color(255, 255, 255)
            })
        }

    }
}